import IGroup from "interfaces/models/IGroup";
import { IUser } from "interfaces/models/IUser";
import { UserPasswordStatus } from "interfaces/models/UserPasswordStatus";
import { UserStatusType } from "interfaces/models/UserStatusType";
import IGroupResponseItem from "interfaces/responses/IGroupResponseItem";
import IUserResponseItem from "interfaces/responses/IUserResponseItem";

const passwordStatusesAdminCanReset = [UserPasswordStatus.Confirmed];

const mapUserResponseItemToUser = (userResponse : IUserResponseItem, groups : IGroupResponseItem[]) : IUser => {
  const user : IUser = {
    userId: userResponse.id,
    emailAddress: userResponse.email,
    applicationCount: userResponse.apps,
    groups: userResponse.groups ? userResponse.groups.map<IGroup>((grp : string) => (
      {
        groupId: grp,
        groupName: groups.find(group => group.id === grp)?.name ?? grp
      })) : [],
    isFederatedUser: userResponse.idp !== null,
    isPortalAdmin: userResponse.admin,
    requests: userResponse.requests,
    mobileNumber: userResponse.phone,
    mobileNumberVerified: userResponse.phoneVerified,
    username: userResponse.name,
    federatedADName: userResponse.idp,
    status: userResponse.enabled ? UserStatusType.Active : UserStatusType.Inactive,
    passwordStatus: userResponse.status,
    mfaOptions: userResponse.mfaOptions ? userResponse.mfaOptions.sort() : [],
    preferredMfa: userResponse.preferredMfa,
    lastModifiedDate: userResponse.lastModifiedDate,
    lastAuthenticatedDate: userResponse.lastAuthenticated,
    adminCanResetPassword: passwordStatusesAdminCanReset.includes(userResponse.status)
  };

  return user;
};

export { mapUserResponseItemToUser };
